import { createContext } from 'react';
import { UserGroupOfficesQuery } from '../app/generated/graphql';

export default createContext<UserGroupOfficesQuery['me']>(null!);
